import * as CommonActions from './commonActions';
import * as DefaultActions from './defaultActions';
import * as ActionCreators from './actionCreators';
import { appConstants } from '../constants/appConstants';
import { push } from 'react-router-redux';

export const displayError = (err, isDialog) => (dispatch, getState) => {
  let errMsg = '';
  if(CommonActions.isDefined(err.error) && CommonActions.isDefined(err.error.message)){
    const { errorType, message } = err.error;
    if(errorType){
      const trans = getState().translations;
      errMsg = trans[errorType] ? trans[errorType] : message;
      if(errorType === appConstants.ERROR_TYPE_UNAUTHORIZED){
        dispatch(ActionCreators.infoMessage(CommonActions.infoMessage(errMsg, false, true)));
      }else{
        dispatch(ActionCreators.infoMessage(CommonActions.errorMessage(errMsg)));
      }
    }else{
      if(err.error.code === appConstants.EXPIRED_TOKEN_ERROR_CODE) {
        dispatch(push(appConstants.ROUTE_ACCESS_DENIED));
        dispatch(DefaultActions.displayCommonHeaderSideMenu());
      } else{
        dispatch(ActionCreators.infoMessage(CommonActions.errorMessage(err.error.message)));
      }
    }
  } else {
    dispatch(ActionCreators.infoMessage(CommonActions.errorMessage(err.statusText)));
  }
  if(isDialog){
    dispatch(ActionCreators.isDisplayMessageDialog(true));
  } else {
    dispatch(ActionCreators.displayMessage(true));
  }
  dispatch(ActionCreators.displayLoader(false));
};
